//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Section.js";
import "../no/SelectDisplayableObject.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/SelectObject.js";
let d=[[[0,"AreaControl",1,0],[0,"Attraction",1,0],[1,"CurveChain",0,"Section",0],[0,"DefaultEdgeContinuity",1,0],[1,"FacetBody",0,"SelectDisplayableObject",0],[1,"Fullness",0,"Expression",0],[0,"FullnessPoint",1,"Point",0],[0,"Patch",1,0],[0,"PickPoint",1,0],[1,"SelectPassThrougCurves",0,"Section",0],[0,"ShapeControlType",1,0],[0,"Tolerance",1,0]],[[["numListItem"],"GetBorderTypeItems",{R_:{markerToNodeListItem:""}},0,0],[["markerToNodeListItem"],"SetBorderTypeItems",{},1,0]],[]];
SPLM.Features.FillHoleBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.FillHoleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.FillHoleBuilder.BorderContinuity = class{
    constructor(borderObject,continuity){
        this.borderObject=borderObject;this.continuity=continuity;}
    get Borderobject(){return this.borderObject}
    set Borderobject(val){this.borderObject = val}
    get Continuity(){return this.continuity}
    set Continuity(val){this.continuity = val}
};

SPLM.Features.FillHoleBuilder.ShapeControlTypes = Object.freeze({
    "None" : "None", "Fullness" : "Fullness", "PassThroughCurves" : "PassThroughCurves", "FitToPoints" : "FitToPoints", "FitToFacet" : "FitToFacet"});

SPLM.Features.FillHoleBuilder.ContinuityTypes = Object.freeze({
    "G0" : "G0", "G1" : "G1", "G2" : "G2"});

export default SPLM;